import { action } from '@ember/object';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import eq from 'ember-truth-helpers/helpers/eq';
import or from 'ember-truth-helpers/helpers/or';
import classNames from 'volta/helpers/class-names';

interface BvConnectedItemSignature {
  Args: {
    focused?: boolean;
    /**
     * The position of the item.
     */
    position?: 'left' | 'right' | 'primary';
  };
  Blocks: {
    default: [];
  };
  Element: HTMLDivElement;
}

export default class BvConnectedItemComponent extends Component<BvConnectedItemSignature> {
  <template>
    <div
      class={{classNames
        'bv-connected__item'
        (if this.focused 'bv-connected__item--focused')
        (if (or (eq @position 'left') (eq @position 'right')) 'bv-connected__item--connection')
        (if (eq @position 'primary') 'bv-connected__item--primary')
      }}
      ...attributes
    >
      {{yield}}
    </div>
  </template>
  /**
   * Whether or not the item is focused.
   *
   * @property focused
   * @private
   * @type {Boolean}
   * @default false
   */
  @tracked focused: boolean = this.args.focused ?? false;

  @action
  handleFocusIn() {
    this.focused = true;
  }

  @action
  handleFocusOut() {
    this.focused = false;
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'BvConnected::Item': typeof BvConnectedItemComponent;
    'bv-connected/item': typeof BvConnectedItemComponent;
  }
}
